import { AxiosError } from "axios";

// DRF throws back either a plain string or { detail | message: string } for
// human-readable errors; pick whichever the server actually sent.
// Empty/whitespace-only strings are treated as no message — axios surfaces a
// 500 with no body as data="", which would otherwise render as a blank bubble.
export const extractServerMessage = (error: unknown): string | undefined => {
  if (!(error instanceof AxiosError)) return undefined;
  const data = error.response?.data;
  if (typeof data === "string") {
    const trimmed = data.trim();
    return trimmed || undefined;
  }
  if (data && typeof data === "object") {
    const candidate =
      (data as { detail?: unknown }).detail ??
      (data as { message?: unknown }).message;
    if (typeof candidate === "string") {
      const trimmed = candidate.trim();
      return trimmed || undefined;
    }
  }
  return undefined;
};
